const translations: { [key: string]: string } = {};
//@ts-ignore
const requireContext = require.context('./', true, /\.json$/);

requireContext.keys().forEach((key: { match: (arg0: RegExp) => any[] }) => {
  const locale = key.match(/\.\/(.*)\.json$/)[1];
  translations[locale] = requireContext(key);
});

export default translations;
